module.exports = __webpack_public_path__ + "img/stadia-home-launch_2x.9ba2de03.jpg";